let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cPL9a")).then(() => parcelRequire('i9hQB'));